import script from "./ArtistProfile.vue?vue&type=script&setup=true&lang=js"
export * from "./ArtistProfile.vue?vue&type=script&setup=true&lang=js"

import "./ArtistProfile.vue?vue&type=style&index=0&id=a748fcfc&lang=scss"
import "./ArtistProfile.vue?vue&type=style&index=1&id=a748fcfc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a748fcfc"]])

export default __exports__